import { useShallow } from 'zustand/react/shallow'

import { Snackbar } from '@/components/Snackbar'
import { useSnackbarStore } from '@/stores/use-snackbar-store'

/** The stack of transient messages, bottom-left over everything else. */
export function Snackbars() {
  const { snackbars, removeSnackbar, setHovered } = useSnackbarStore(
    useShallow(s => ({
      snackbars: s.snackbars,
      removeSnackbar: s.removeSnackbar,
      setHovered: s.setHovered,
    })),
  )

  return (
    <div className="pointer-events-none fixed bottom-5 left-5 z-50 flex flex-col-reverse items-start gap-2">
      {snackbars.map(snackbar => (
        <div key={snackbar.id} className="pointer-events-auto animate-snackbar">
          <Snackbar
            type={snackbar.type}
            title={snackbar.title}
            action={
              snackbar.action && {
                label: snackbar.action.label,
                onClick: () => {
                  snackbar.action?.onClick()
                  removeSnackbar(snackbar.id)
                },
              }
            }
            onClose={() => removeSnackbar(snackbar.id)}
            onHover={hovered => setHovered(snackbar.id, hovered)}
            duration={snackbar.duration}
            isPaused={snackbar.isPaused}
          />
        </div>
      ))}
    </div>
  )
}
